<template>
  <div class="carousel" v-if="swiperImages.length > 0">
    <swiper
      ref="carousel"
      :options="swiperOptions"
    >
      <swiper-slide
        v-for="(image, index) in swiperImages"
        :key="index"
      >
        <img
          :src="image.url"
          :alt="image.alt"
          v-if="image.url"
        />
        <img
          :src="image.urls.desktop"
          :alt="image.alt"
          v-else-if="isDesktop"
        />
        <img
          :src="image.urls.mobile"
          :alt="image.alt"
          v-else
        />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { mapGetters } from 'vuex'

export default {
  name: 'TheCarousel',
  props: {
    images: {
      type: Array,
      required: true
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    delay: {
      type: Number,
      default: 5000
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      loaded: false,
      realIndex: 0,
      swiperImages: [],
      swiperOptions: {
        slidesPerView: 1,
        centeredSlides: true,
        allowTouchMove: false,
        preloadImages: true,
        updateOnImagesReady: true,
        loopAdditionalSlides: 10,
        loop: true,
        effect: 'fade',
        speed: 1500,
        fadeEffect: {
          crossFade: true
        },
        autoplay: this.autoplay ? { delay: this.delay } : false
      }
    }
  },
  computed: {
    ...mapGetters('page', {
      categoryIndex: 'getCategoryIndex'
    }),
    ...mapGetters('breakpoints', [
      'isDesktop'
    ]),
    swiper () {
      return this.$refs.carousel.swiper
    }
  },
  watch: {
    categoryIndex () {
      if (this.swiper.realIndex !== this.categoryIndex) {
        this.showImage(this.categoryIndex)
      }
    },
    images () {
      this.updateImages()
    }
  },
  created () {
    this.updateImages()
  },
  methods: {
    showImage (index) {
      this.swiper.autoplay.stop()
      this.swiper.slideTo(index)
    },
    updateImages () {
      this.swiperImages = []
      this.$nextTick(() => {
        this.swiperImages = [...this.images]
      })
    }
  }
}
</script>

<style lang="scss">
  .carousel{

    // Image

    img{
      @include media("large"){
        // filter: grayscale(1);
        // transition-timing-function: $ease-in-out-sine;
        // transition-duration: 2000ms;
        // transition-property: filter;
        // transition-delay: 500ms;

        &:hover{
          // filter: grayscale(0.2);
        }
      }

      width: 100%;
      height: 100vh;
      object-fit: cover;
      object-position: 50% 20%;
    }
  }
</style>
